import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';

export const templateLicensePrePaidSubForm = document.createElement('template');

templateLicensePrePaidSubForm.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='form-wrapper' id='license-pre-paid-form-wrapper'>

    <gz-form-field id='license-pre-paid-form-field' class='label-mw-250' label='' required manualValidation>
      <gz-input gz-form-input placeholder='' inputWidth="240"></gz-input>
      <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>

    <gz-button id='check-license-validity-button' type='outline' buttonHeight='small' buttonFontSize='small' disabled></gz-button>

    <p class='form-subtitle-info hidden' id='info-message-for-disabled-license-key-field'></p>

    <gz-info-box class='hidden license-details-info-box' severity='warning' id='incompatible-product-notice-container'></gz-info-box>

    <gz-info-box class='hidden license-details-info-box' severity='error' id='incompatible-addon-with-product-error-container'></gz-info-box>

    <gz-info-box class='hidden license-details-info-box' severity='warning' id='valid-license-with-issues-warning-container'></gz-info-box>


    <div class='hidden pre-paid-license-details-container' id='pre-paid-license-details'>
      <gz-title fontSize='11' fontWeight='600' class='title' id='product-details-title'></gz-title>

      <gz-form-field id='product-name' class='label-mw-250' label='' readonly>
        <gz-input gz-form-input placeholder='' inputWidth="240"></gz-input>
      </gz-form-field>

      <gz-form-field id='validity' class='label-mw-250' label='' readonly>
        <gz-input gz-form-input placeholder='' inputWidth="240"></gz-input>
      </gz-form-field>

      <gz-form-field id='available-seats' class='label-mw-250' label='' readonly>
        <gz-input gz-form-input placeholder='' inputWidth="240"></gz-input>
      </gz-form-field>

      <gz-form-field id='available-seats-for-servers' class='hidden label-mw-250' label='' readonly>
        <gz-input gz-form-input placeholder='' inputWidth="240"></gz-input>
      </gz-form-field>

      <gz-form-field id='available-seats-for-exchange-mailboxes' class='hidden label-mw-250' label='' readonly>
        <gz-input gz-form-input placeholder='' inputWidth="240"></gz-input>
      </gz-form-field>

      <gz-form-field id='available-seats-for-mobile-devices' class='hidden label-mw-250' label='' readonly>
        <gz-input gz-form-input placeholder='' inputWidth="240"></gz-input>
      </gz-form-field>

    </div>

    <gz-mdr-contact-details-section class='hidden'></gz-mdr-contact-details-section>

  </div>
`;
